/**
 * @generated SignedSource<<9834b28da54932ca4814065fc9d25bf4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AcceptOfferDialog_offer$data = {
  readonly company: {
    readonly providesOwnDistribution: boolean;
  };
  readonly id: string;
  readonly " $fragmentType": "AcceptOfferDialog_offer";
};
export type AcceptOfferDialog_offer$key = {
  readonly " $data"?: AcceptOfferDialog_offer$data;
  readonly " $fragmentSpreads": FragmentRefs<"AcceptOfferDialog_offer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AcceptOfferDialog_offer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CompanyNode",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "providesOwnDistribution",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "OfferNode",
  "abstractKey": null
};

(node as any).hash = "5da842790e8c606d851ab69522d8273f";

export default node;
